import axios from "axios";
import React, { useState, useEffect, useRef } from "react";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import AutoComplete from '@mui/material/Autocomplete';
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'
function PackMin(){
    const [packcats,setpackcats] = useState([]);
    const [insur,setInsur] = useState([]);
    const [Packmin, setPackmin] = useState([]);
    const [items, setItems] = useState([]);
    const inputRefs = useRef([]);
    const [rows, setRows] = useState([]);
    const [tabrows, setTabRows] = useState([]);
    const [subdata, setsubData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [minData,setminData]=useState({
        "pack":'',
        "insur":'',
        "min":'',
        "min_test":'',
        "minamount":'',
        "status":'',
        "addedby":'',
        "ip_add":''
    });
useEffect(() => {
  const fetchData = async () => {
    try {
      const [minResponse] = await Promise.all([
        axios.get(`${baseUrl}min-search/`),
      ]);
      setItems(minResponse.data);
    } catch (error) {
      console.log(error);
    }
  };
  fetchData();
  }, []);

    const handleChange = (event) => {
        setminData({
            ...minData,
            [event.target.name]:event.target.value
        });
    }
  const handleKeyDown = (e, index) => {
      const newRows = [...rows];
      switch (e.keyCode) {
        // Handle Shift key
        case 16:
          e.preventDefault();
          if (index === rows.length - 1) {
            newRows.push({ id:'', comp: '', amount: '' });
          }
          break;
          case 90:
          e.preventDefault();
            newRows.splice(index, 1);
          break;
        // Handle arrow up key
        case 38:
          e.preventDefault();
          if (newRows[index].selectedItem === 0) {
            newRows[index].selectedItem = items.length - 1;
          } else {
            newRows[index].selectedItem--;
          }
          setRows(newRows);
          break;
        // Handle arrow down key
        case 40:
          e.preventDefault();
          if (newRows[index].selectedItem === items.length - 1) {
            newRows[index].selectedItem = 0;
          } else {
            newRows[index].selectedItem++;
          }
          setRows(newRows);
          break;
        default:
          break;
      }
      setRows(newRows);
    };

  const handleSelect = (value, index) => {
    // Check if value is undefined or null
    if (value === undefined || value === null) {
      // Handle the scenario where the value is cleared or backspaced
      const newRows = [...rows];
      newRows[index] = { id: '', comp: '', amount: '' };
      setRows(newRows);
    } else {
      // Handle the selection
      const selectedItem = items.find(item => item.comp === value);
      if (selectedItem) {
        const newRows = [...rows];
        newRows[index] = {
          id: selectedItem.id,
          comp: selectedItem.comp,
          amount: selectedItem.amount
        };
        setRows(newRows);
      }
    }
  };

  const handleAmountChange = (e, index) => {
    const newRows = [...rows];
    newRows[index].amount = parseFloat(e.target.value) || 0;
    setRows(newRows);
  };

    const handleAddRow = () => {
        const newRows = [...rows, { id: '', comp: '', amount: '' }];
        setRows(newRows);
      };

  useEffect(() => {
      inputRefs.current[inputRefs.current.length - 1]?.focus();
  }, [rows]);

  const handleDeleteRow = (index) => {
    const newRows = [...rows];
    newRows.splice(index, 1);
    setRows(newRows);
    inputRefs.current.splice(index, 1);
  };

    const formSubmit = () =>{
        const _formData = new FormData();
        _formData.append('pack',minData.cat_id);
        _formData.append('insur',minData.insur_id);
        _formData.append('min', rows.map(row => row.id).join(','));
        _formData.append('min_test', rows.map(row => row.comp).join(','));
        _formData.append('minamount', rows.map(row => row.amount).join(','));
        _formData.append('status','1');
        _formData.append('addedby', userName);
        _formData.append('ip_add', ipAddress);
          _formData.append('location', userLocation);

        try{
            axios.post(baseUrl+'create-pack-min/', _formData, {
                headers : {
                    'content-type': 'multiple/form-data'
                }
            })
            .then(function (response) {
               if(response.status==200 || response.status==201){
                    Swal.fire({
                        title: 'Data has been updated',
                        icon: 'success',
                        timer:5000,
                        showConfirmButton: false
                    });

               }
               setTimeout(() => {
                        window.location.href = ('/pack-min');
                        }, 3000);
            });
            }catch(error){
                console.log(error);
            }
        };

    useEffect(() => {
        try{
            axios.get(baseUrl+'create-pack/')
            .then(function (response) {
                setpackcats(response.data);
            });
        }catch(error){
            console.log(error);
        }
        try{
            axios.get(`${baseUrl}insur-cmpy/`)
      .then(response => {
        setInsur(response.data);
      })
        }catch(error){
            console.log(error);
        }
        },[]);
useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
      if (Packmin.length > 0) {
        setTabRows(Packmin);
      }
  }, [Packmin]);
  function fetchData() {
    setIsLoading(true);
    axios.get(`${baseUrl}view-pack-min/`)
      .then(response => {
        setPackmin(response.data);
        setIsLoading(false);
      })
      .catch(error => {
        console.log(error);
        setIsLoading(false);
      });
  }

    const handleDelete = (id) => {
      Swal.fire({
        title: 'Confirm',
        text: 'Are you sure you want to clear the fields for this entry?',
        icon: 'info',
        confirmButtonText: 'Continue',
        showCancelButton: true
      }).then((result) => {
        if (result.isConfirmed) {
          try {
            // Construct the payload with the fields you want to clear
            const payload = {
              min: null,
              min_test: null,
              minamount: null,
               addedby: userName,
               ip_add: ipAddress,
            };
            // Use Axios to send a PUT request to update the entry
            axios.put(baseUrl + 'delete-pack-min/' + id, payload)
              .then(function (response) {
                Swal.fire('success', 'The fields have been cleared');
                setTimeout(() => {
                        window.location.href = ('/pack-min');
                        }, 3000);
              });
          } catch (error) {
            Swal.fire('error', 'There was a problem updating the entry');
          }
        } else {
          Swal.fire('Cancelled', 'No changes have been made');
        }
      });
    };

useEffect(() => {
  const fetchminData = async () => {
    try {
      // Flatten the min IDs from all rows into a single array
      const allminIds = tabrows.flatMap(row => row.min.split(','));

      // Remove duplicates and empty strings, then map IDs to API requests
      const requests = [...new Set(allminIds)].filter(Boolean).map(id =>
        axios.get(`${baseUrl}edit-minor-comp/${id}`)
      );
      const responses = await Promise.all(requests);
      const minDataArray = responses.map(response => response.data);
      setsubData(minDataArray);
    } catch (error) {
      console.error(error);
    }
  };

  fetchminData();
}, [tabrows]); // Dependency on tabRows to re-fetch when it changes
const columns = [
  { field: 'id', headerName: 'Id', width: 50 },

  {
    field: 'pack_subcategory',
    headerName: 'Pack SubCategory',
    width: 200,
    renderCell: (params) => params.row.pack?.packsubcat || 'N/A',
  },

  {
    field: 'insurance_company',
    headerName: 'Insurance',
    width: 250,
    renderCell: (params) => params.row.insur?.company || 'N/A',
  },

  {
    field: 'min_test',
    headerName: 'Min Treat Name',
    width: 300,
    renderCell: (params) => {
      if (!params.row.min_test) return 'N/A';
      const minTests = params.row.min_test.split(',').map((t) => t.trim());
      return (
        <div style={{ whiteSpace: 'normal', lineHeight: '1.5' }}>
          {minTests.map((test, index) => (
            <div key={index}>{test}</div>
          ))}
        </div>
      );
    },
  },

  {
    field: 'minamount',
    headerName: 'Min Amount',
    width: 150,
    renderCell: (params) => {
      if (!params.row.minamount) return 'N/A';
      const minAmounts = params.row.minamount.split(',').map((a) => a.trim());
      return (
        <div style={{ whiteSpace: 'normal', lineHeight: '1.5' }}>
          {minAmounts.map((amt, index) => (
            <div key={index}>{amt}</div>
          ))}
        </div>
      );
    },
  },

  { field: 'addedby', headerName: 'Added By', width: 100 },

  {
    field: 'edit',
    headerName: 'Edit',
    width: 100,
    renderCell: (params) => (
      <Link to={`/edit-packmin/${params.row.id}`} className="btn btn-warning">
        Edit
      </Link>
    ),
  },

  {
    field: 'delete',
    headerName: 'Action',
    width: 120,
    renderCell: (params) => (
      <button
        onClick={() => handleDelete(params.row.id)}
        className="btn btn-danger btn-sm ms-1"
      >
        <i className="fa-solid fa-trash-can"></i>
      </button>
    ),
  },
];
const getRowHeight = () => {
  return 150;
};
    return (
        <section className="container mt-4">
            <div className="row">

              <div className='col-md-9 col-12 mb-2'>
                <div className='card'>
                    <h4 className='card-header'>Add Package Price</h4>
                    <div className='card-body'>
                        <form>
                        <div className="mb-3">
                            <label htmlFor="cat_id" className="form-label">Package SubCategory</label>
                            <select name="cat_id" value={minData.cat_id} onChange={handleChange} className="form-control">
                            <option>Choose Package SubCategory </option>
                                {packcats.map((category,index) => {return <option key={index} value={category.id}>{category.packsubcat}
                                </option>})}
                            </select>
                          </div>
                          <div className="mb-3">
                            <label htmlFor="insur_id" className="form-label">Insurance</label>
                            <select name="insur_id" value={minData.insur_id} onChange={handleChange} className="form-control">
                            <option>Choose Insurance</option>
                                {insur.map((insurer,index) => {return <option key={index} value={insurer.id}>
                                {insurer.company}
                                </option>})}
                            </select>
                          </div>

    <div className="table-responsive">
      <table className="erp-table-modern">
        <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th>ID</th>
          <th>Name</th>
          <th>Total</th>
          <th>Action</th>
        </tr>
      </thead>

      <tbody>
      {rows.map((row, index) => (
        <tr key={index}>
        <td>
        <input
            type="text"
            className="ms-2 me-5 mt-4"
            style={{width: 80}}
            name="ltest_id"
            value={row.id}
             onChange={(e) => handleChange(e, index, 'id')}
            readOnly
          />
          </td>
              <td >
                <AutoComplete
                  className="form-control mt-2"
                  options={items.map(item => item.comp)}
                  value={row.comp}
                  onChange={(event, value) => handleSelect(value, index)}
                  onInputChange={(event, newInputValue) => {
                    // Update input value
                    setRows(prevRows => {
                      const updatedRows = [...prevRows];
                      updatedRows[index].comp = newInputValue;
                      return updatedRows;
                    });
                  }}
                 onKeyDown={e => handleKeyDown(e, index)}
                 renderInput={(params) => (
                  <div ref={params.InputProps.ref}
                  >
                    <input className="form-control" type="text" {...params.inputProps} focused autoFocus
                           fullWidth
                           style={{
                              width: 300,
                              background: "#F7EEFF",
                              }}
                     />
                  </div>
                )}
                 ref={(el) => inputRefs.current[index] = el}
                />
              </td>
              <td>
              <input
                type="number"
                className="ms-2 me-5"
                value={row.amount}
                name="amount"
                style={{width: 100}}
                onChange={handleChange}
                onChange={(e) => handleAmountChange(e, index)}

              />
              </td>
              <td>
                <button className="btn btn-danger" type="button" onClick={() => handleDeleteRow(index)}>Delete</button>
              </td>
        </tr>
      ))}
         </tbody>
      </table>
      <button className="btn btn-success addmore mt-4" type="button" onClick={handleAddRow}>Add More</button>
      </div>

      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <button type="button" onClick={formSubmit} className="btn btn-primary">Submit</button>
      </div>

                </form>
            </div>
        </div>
      </div>
    </div>
                    <div style={{ height: "100%", width: "100%" }}>
         {tabrows.length > 0 && (
          <DataGrid className="mt-4"
            sx={{
              boxShadow: 4,
              border: 4,
              borderColor: 'primary.light',
              '& .MuiDataGrid-cell:hover': {
                color: 'primary.main',
              },
            }}
            getRowHeight={getRowHeight}
            pageSize={28}
            rows={tabrows}
            columns={columns}
            components={{
                Toolbar: GridToolbar,
             }}
            autoHeight
          />
          )}
          </div>

        </section>

)
}

export default PackMin;